import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { IonLoading, IonButton, useIonViewWillEnter } from '@ionic/react';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { PageLayout } from 'containers/layout';
import OrderActions, { OrderSelectors } from 'redux/OrderRedux';
import MenuItemDetail from 'containers/order/MenuItemDetail';

function MenuItemDetailPage() {
  const history = useHistory();
  const params = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const loading = useSelector(OrderSelectors.selectMenuItemsLoading);
  const { itemId, locationId: venueId } = params;
  const [quantity, setQuantity] = useState(1);
  const [editing, setEditing] = useState(false);
  const item = useSelector(OrderSelectors.selectMenuItem(venueId, itemId));
  const [modifierData, setModifierData] = useState([])
  const [groupId, setGroupId] = useState(null);
  const [buttonEnable, setButtonEnable] = useState(false)

  const handleAddCart = () => {
    if (editing) {
      dispatch(OrderActions.editItemInCart(location.state.uuid, quantity, modifierData));
    } else {
      dispatch(OrderActions.addItemToCart(venueId, quantity, item, modifierData));
    }

    history.replace(`/locations/${venueId}/cart/review`, {
      direction: 'forward',
    });
  };

  useIonViewWillEnter(() => {
    if (location.state && location.state.quantity) {
      setQuantity(location.state.quantity);
      setEditing(true);
    } else {
      setQuantity(1);
      setEditing(false);
    }
    dispatch(OrderActions.loadMenuItems(venueId));
  });

  return (
    <PageLayout
      back
      title={item && item.name}
      footer={
        <IonButton
          color="tertiary"
          expand="block"
          fill="solid"
          onClick={handleAddCart}
          disabled={!buttonEnable}
        >
          Add to Cart
        </IonButton>
      }
    >
      <IonLoading isOpen={loading} message="Loading..." />
      {item && (
        <MenuItemDetail
          item={item}
          onChangeQuantity={setQuantity}
          quantity={quantity}
          modifierData={modifierData}
          setModifierData={setModifierData}
          setGroupId={setGroupId}
          setButtonEnable={setButtonEnable}
        />
      )}
    </PageLayout>
  );
}

export default MenuItemDetailPage;
